<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title">
          {{ model == 'add' ? '新增车辆' : '编辑' }}
        </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <div
      class="content-create-car-page"
      :style="'height:' + dialogBodyHight + 'px;overflow:scroll;'"
    >
      <div class="left">
        <el-tabs
          tab-position="left"
          v-model="activeName"
          @tab-click="handleClick"
          style="background-color: #eee"
        >
          <el-tab-pane
            v-for="(item, index) in activeNameList"
            :key="index"
            :label="item.label"
            :name="item.value"
            :ref="item.value"
            :disabled="item.disabled"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="right" style="margin-left: 10px">
        <first
          v-show="activeName == 'first'"
          :model="model"
          :parkSpace="parkSpace"
          @getNewSpaceDetails="getNewSpaceDetails"
          ref="first"
          @getQuestionResult="getQuestionResult"
        ></first>
        <second
          v-if="activeName == 'second'"
          :saveBtnShow.sync="saveBtnShow"
          @getQuestionResult="getQuestionResult"
          :parkSpace="parkSpace"
          ref="second"
        ></second>
        <third
          v-if="activeName == 'third'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="third"
        ></third>
        <fourth
          v-if="activeName == 'fourth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="fourth"
        ></fourth>
        <fifth
          v-if="activeName == 'fifth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="fifth"
        ></fifth>
        <sixth
          v-if="activeName == 'sixth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="sixth"
        ></sixth>
        <seventh
          v-if="activeName == 'seventh'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="seventh"
        ></seventh>
        <eighth
          v-if="activeName == 'eighth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="eighth"
        ></eighth>
        <!-- <ninth
          v-if="activeName == 'ninth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="ninth"
        ></ninth> -->
        <tenth
          v-if="activeName == 'tenth'"
          :saveBtnShow.sync="saveBtnShow"
          :parkSpace="parkSpace"
          @getQuestionResult="getQuestionResult"
          ref="tenth"
        ></tenth>
      </div>
    </div>
    <template slot="footer">
      <el-button
        @click="formSubmit"
        size="small"
        v-show="saveBtnShow && activeName != activeNameList[activeNameList.length - 1].value"
        type="primary"
        ><span class="el-icon-circle-plus-outline"></span> 保存</el-button
      >
      <el-button
        @click="nextStep(false)"
        size="small"
        v-show="activeName != activeNameList[activeNameList.length - 1].value"
        type="primary"
        style="margin-right: 15px"
        ><span class="el-icon-right"></span>下一步</el-button
      >
      <el-button
        @click="nextStep('over')"
        size="small"
        v-show="activeName == activeNameList[activeNameList.length - 1].value"
        type="primary"
        style="margin-right: 15px"
        ><span class="el-icon-check"></span>完成</el-button
      >
    </template>
  </el-dialog>
</template>
<style lang="scss" scoped>
.content-create-car-page {
  display: flex;
  width: 100%;
  .left {
    width: 110px;
    flex-shrink: 0;
    flex-grow: 0;
  }
  .right {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    margin-left: 10px;
    width: 200px;
    flex-shrink: 1;
    flex-grow: 1;
    background-color: #fff;
  }
}
</style>
<script>
import first from './a-base-info.vue';
import second from './b-area.vue';
import third from './c-rules.vue';
import fourth from './d-passage.vue';
import fifth from './e-device.vue';
import sixth from './f-box.vue';
import seventh from './g-box-personnel.vue';
import eighth from './h-charge.vue';
import ninth from './i-parameter.vue';
import tenth from './j-holiday.vue';
import { getCreateStage, saveCreateStage } from '@/views/v4ward/carv2/merge/api/park-merge.js';
export default {
  components: { first, second, third, fourth, fifth, sixth, seventh, eighth, ninth, tenth },
  data() {
    return {
      model: 'add',
      saveBtnShow: true,
      parkSpace: {},
      activeName: 'first',
      activeNameList: [
        {
          label: '1 基本信息',
          value: 'first',
          disabled: false,
        },
        {
          label: '2 区域管理',
          value: 'second',
          disabled: true,
        },
        {
          label: '3 通行规则',
          value: 'third',
          disabled: true,
        },
        {
          label: '4 通道管理',
          value: 'fourth',
          disabled: true,
        },
        {
          label: '5 设备管理',
          value: 'fifth',
          disabled: true,
        },
        {
          label: '6 岗亭管理',
          value: 'sixth',
          disabled: true,
        },
        {
          label: '7 岗亭人员',
          value: 'seventh',
          disabled: true,
        },
        {
          label: '8 临停收费',
          value: 'eighth',
          disabled: true,
        },
        // {
        //   label: '9 参数配置',
        //   value: 'ninth',
        //   disabled: true,
        // },
        {
          label: '9 节假日',
          value: 'tenth',
          disabled: true,
        },
      ],
      dialogVisible: false,
      dialogFull: false,
      defaultSaveBtns: ['second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth'],
    };
  },
  computed: {
    dialogBodyHight() {
      if (this.dialogFull) {
        return this.bodyHeight - 180;
      } else {
        return this.bodyHeight - 270;
      }
    },
  },
  methods: {
    openDialog(type, row) {
      console.log(this.bodyHeight);
      if (type == 'add') {
        this.model = type;
        this.activeNameList.forEach((ele) => {
          if (ele.value != 'first') {
            ele.disabled = true;
          }
        });
        console.log(this.activeNameList);
        this.saveBtnShow = true;
        this.dialogVisible = true;
      } else {
        this.model = type;
        this.parkSpace = row;
        this.dialogVisible = true;
        getCreateStage({ spaceId: this.parkSpace.id, tenantId: this.parkSpace.tenantId }).then(
          (res) => {
            if (!res.data) {
              this.activeNameList.forEach((ele) => {
                ele.disabled = false;
              });
            } else {
              this.activeNameList = JSON.parse(res.data);
            }

            setTimeout(() => {
              this.$refs.first.setDefaultForm(this.parkSpace);
            });
          }
        );
      }
      this.activeName = 'first';
    },
    nextStep(over) {
      if (over) {
        this.dialogVisible = false;
        this.$emit('onload');
      } else {
        this.$refs[this.activeName].formSubmit(true);
      }
    },
    formSubmit() {
      console.log(this.$refs);
      this.$refs[this.activeName].formSubmit();
    },
    handleClick() {
      if (this.defaultSaveBtns.indexOf(this.activeName) > -1) {
        this.saveBtnShow = false;
      } else {
        this.saveBtnShow = true;
      }
    },
    getNewSpaceDetails(parkSpace) {
      this.parkSpace = parkSpace;
    },
    getQuestionResult(result) {
      if (result) {
        let activeNameIndex = 0;
        this.activeNameList.forEach((ele, index) => {
          if (ele.value == this.activeName) {
            activeNameIndex = index;
            if (index != 9) {
              this.activeNameList[index + 1].disabled = false;
            }
          }
        });
        activeNameIndex += 1;
        console.log(activeNameIndex);
        this.activeName = this.activeNameList[activeNameIndex].value;
        if (this.defaultSaveBtns.indexOf(this.activeName) > -1) {
          this.saveBtnShow = false;
        } else {
          this.saveBtnShow = true;
        }
      }
      let form = {
        spaceId: this.parkSpace.id,
        tenantId: this.parkSpace.tenantId,
        createStage: JSON.stringify(this.activeNameList),
      };
      saveCreateStage(form).then((res) => {});
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (done) {
            done();
          }
          this.$emit('onload');
          self.dialogVisible = false;
        })
        .catch(() => {});
    },
  },
  created() {},
};
</script>
